export const AccessToken = "access_token";
export const RefreshToken = "refresh_token";
export const Authentication = "authentication";

export const Authenticated = "authenticated";
export const NoAuthenticated = "no-authenticated";